//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

const POPOVER_WIDTH = 320;
const POPOVER_OFFSET_Y = 12;

export default {
  name: 'SharePopover',

  props: {
    visible: { type: Boolean, default: false },
    triggerEl: { type: [Object, Element], default: null },
  },

  data() {
    return {
      top: 0,
      left: 0,
      openAbove: false,
      openLeft: false,
      copied: false,
      copiedTimer: null,
      shareUrl: '',
    };
  },

  computed: {
    positionStyle() {
      return {
        position: 'fixed',
        top: `${this.top}px`,
        left: `${this.left}px`,
        width: `${POPOVER_WIDTH}px`,
        zIndex: 11000,
      };
    },
  },

  watch: {
    visible(now) {
      if (now) {
        this.shareUrl = window.location.href;
        this.copied = false;
        if (this.copiedTimer) { clearTimeout(this.copiedTimer); this.copiedTimer = null; }
        this.attachListeners();
      } else {
        this.detachListeners();
        if (this.copiedTimer) { clearTimeout(this.copiedTimer); this.copiedTimer = null; }
      }
    },
    triggerEl() {
      if (this.visible) this.$nextTick(() => this.computePosition());
    },
  },

  beforeDestroy() {
    this.detachListeners();
    if (this.copiedTimer) clearTimeout(this.copiedTimer);
  },

  methods: {
    computePosition() {
      if (!this.triggerEl) return;
      const r = this.triggerEl.getBoundingClientRect();
      const vw = window.innerWidth;
      const vh = window.innerHeight;
      const popW = POPOVER_WIDTH;
      const popH = (this.$el && this.$el.offsetHeight) || 80;

      const spaceBelow = vh - r.bottom - POPOVER_OFFSET_Y;
      const spaceAbove = r.top - POPOVER_OFFSET_Y;
      this.openAbove = spaceBelow < popH && spaceAbove >= popH;

      const top = this.openAbove
        ? r.top - POPOVER_OFFSET_Y - popH
        : r.bottom + POPOVER_OFFSET_Y;

      const rightAligned = r.right - popW;
      this.openLeft = rightAligned < 8;
      const rawLeft = this.openLeft ? r.left : rightAligned;

      this.top = top;
      this.left = Math.max(8, Math.min(vw - popW - 8, rawLeft));
    },

    attachListeners() {
      this.$nextTick(() => {
        this.computePosition();
        this.$refs.urlInput?.focus();
      });
      document.addEventListener('mousedown', this.onOutsideClick);
      document.addEventListener('keydown', this.onKeydown);
      window.addEventListener('scroll', this.computePosition, true);
      window.addEventListener('resize', this.close);
    },

    detachListeners() {
      document.removeEventListener('mousedown', this.onOutsideClick);
      document.removeEventListener('keydown', this.onKeydown);
      window.removeEventListener('scroll', this.computePosition, true);
      window.removeEventListener('resize', this.close);
    },

    onOutsideClick(e) {
      if (!this.$el || !this.$el.contains) return;
      if (this.$el === e.target || this.$el.contains(e.target)) return;
      if (this.triggerEl && this.triggerEl.contains(e.target)) return;
      this.close();
    },

    onKeydown(e) {
      if (e.key === 'Escape') this.close();
    },

    close() {
      this.triggerEl?.focus();
      this.$emit('close');
    },

    async copyUrl() {
      try {
        await navigator.clipboard.writeText(this.shareUrl);
        this.copied = true;
        if (this.copiedTimer) clearTimeout(this.copiedTimer);
        this.copiedTimer = setTimeout(() => {
          this.copied = false;
          this.copiedTimer = null;
        }, 2000);
      } catch {
        this.$refs.urlInput?.select();
      }
    },
  },
};
